import React, { FC } from 'react';
import Modal, { ModalHeader, ModalTitle, ModalBody, ModalFooter } from '../../components/bootstrap/Modal';
import Icon from '../../components/icon/Icon';
import './RenewTokensModal.scss';

interface IRenewTokensModalProps {
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
	onRenew: () => void;
	isRenewing: boolean;
}

const RenewTokensModal: FC<IRenewTokensModalProps> = ({ isOpen, setIsOpen, onRenew, isRenewing }) => {
	return (
		<Modal
			isOpen={isOpen}
			setIsOpen={setIsOpen}
			isCentered
			isStaticBackdrop={isRenewing}
			titleId='renewTokensModalTitle'
			size='sm'>
			<ModalHeader setIsOpen={isRenewing ? undefined : setIsOpen}>
				<ModalTitle id='renewTokensModalTitle'>Renew Fleet Sage access</ModalTitle>
			</ModalHeader>
			<ModalBody className='text-center'>
				<div className='renew-tokens-modal-icon-wrap'>
					<Icon icon='Subscriptions' className='renew-tokens-modal-icon' />
				</div>
				<p className='fw-bold mb-1'>You&apos;re out of tokens</p>
				<p className='text-muted mb-0'>
					Fleet Sage and AI Fleet Manager are paused until you renew. Hit Renew
					below to restore access right away.
				</p>
			</ModalBody>
			<ModalFooter className='justify-content-center'>
				<button
					type='button'
					className='renew-tokens-modal-cancel-btn'
					disabled={isRenewing}
					onClick={() => setIsOpen(false)}>
					Not now
				</button>
				<button
					type='button'
					className='renew-tokens-modal-btn'
					disabled={isRenewing}
					onClick={onRenew}>
					{isRenewing ? 'Renewing…' : 'Renew'}
				</button>
			</ModalFooter>
		</Modal>
	);
};

export default RenewTokensModal;